/**
 * @class
 * @function ToggleBoxes
 */
if (!customElements.get('toggle-box')) {
  class ToggleBox extends HTMLElement {

    constructor() {
      super();
    }

    connectedCallback() {
      this.button = this.querySelector('.toggle-box--button');

      this.button.addEventListener('click', () => {
        
        // 1. Find the parent container
        const parent = this.parentElement;

        // 2. Find all other toggle-boxes inside that parent
        if (parent) {
          const siblings = parent.querySelectorAll('toggle-box');
          
          siblings.forEach((sibling) => {
            // 3. If it's not the one we just clicked, close it
            if (sibling !== this) {
              sibling.removeAttribute('open');
            }
          });
        }

        // 4. Toggle the clicked one (Open/Close)
        this.toggleAttribute('open');
      });
    }
  }
  customElements.define('toggle-box', ToggleBox);
}